export const getEnvVar = key => process.env[key];

export default {};
